/* eslint-disable jsx-a11y/anchor-is-valid */
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import {
  setVoice,
  setMicValue,
  setConsistency,
  setEnableMidiFlag,
  setWidgetStarted,
  setShowGhost,
  setAutoLabel,
  setApplyGhost,
  setWrongMicInput,
  setWrongMidiInput,
  setSustainPedalNTToggle,
} from "../../store/actions";

const SettingsPopup = (props) => {
  const handleVoiceToggle = (event) => {
    if (event.target.checked) {
      props.setVoice(true);
    } else {
      if (props.widgetStarted) {
        props.setWidgetStarted(false);
      }
      props.setVoice(false);
    }
  };
  const handleConsistencyToggle = (event) => {
    if (event.target.checked) {
      props.setConsistency(true);
    } else {
      props.setConsistency(false);
    }
  };
  const handleSliderChange = (event) => {
    props.setMicValue(parseFloat(event.target.value));
  };
  const handleEnableMidi = (event) => {
    props.setEnableMidiFlag(event.target.checked);
  };
  const handleTunnerToggle = (event) => {
    if (event.target.checked) {
      props.setWidgetStarted(true);
      if (!props.voiceDetect) {
        props.setVoice(true);
      }
    } else {
      props.setWidgetStarted(false);
    }
  };
  const handleShowGhost = () => {
    props.setShowGhost(!props.showGhost);
  };
  const handleApplyGhost = () => {
    props.setApplyGhost(!props.applyGhost);
  };
  const handleAutoLabel = () => {
    props.setAutoLabel(!props.autoLabel);
  };
  return (
    <div>
      <Modal
        size="lg"
        show={props.show}
        onHide={() => props.toggleModal()}
        aria-labelledby="settings-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title id="settings-popup">Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-left">
          <div className="row mb-2">
            <div className="col-5">
              <label className="form-label noselect" htmlFor="mic-switch">
                Microphone input
              </label>
            </div>
            <div className="col-7 settings-group">
              <input
                className="settings settings-light"
                id="mic-switch"
                type="checkbox"
                checked={props.voiceDetect}
                onChange={handleVoiceToggle}
              />
              <label className="settings-btn" htmlFor="mic-switch"></label>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-5">
              <label className="form-label noselect" htmlFor="show-ghost">
                Show ghost tones
              </label>
            </div>
            <div className="col-7 settings-group">
              <input
                className="settings settings-light"
                id="show-ghost"
                type="checkbox"
                checked={props.showGhost}
                onChange={handleShowGhost}
              />
              <label className="settings-btn" htmlFor="show-ghost"></label>
            </div>
            <div className="col-5">
              <label className="form-label noselect" htmlFor="show-ghost">
                MIDI triggered Scale Change
              </label>
            </div>
            <div className="col-7 settings-group">
              <input
                className="settings settings-light"
                id="apply-ghost"
                type="checkbox"
                checked={props.applyGhost}
                onChange={handleApplyGhost}
              />
              <label className="settings-btn" htmlFor="apply-ghost"></label>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-5">
              <label className="form-label noselect" htmlFor="tuner-switch">
                Precision Tuner
              </label>
            </div>
            <div className="col-7 settings-group">
              <input
                className="settings settings-light"
                id="tuner-switch"
                type="checkbox"
                checked={props.widgetStarted}
                onChange={handleTunnerToggle}
              />
              <label className="settings-btn" htmlFor="tuner-switch"></label>
            </div>
          </div>
          {props.voiceDetect && (
            <div>
              <div className="row mb-2">
                <div className="col-5">
                  <label className="form-label noselect" htmlFor="slider">
                    Mic Senstivity
                  </label>
                </div>
                <div className="col-6 settings-group mic-slider-container">
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.05"
                    value={props.sliderValue}
                    className="slider"
                    id="slider"
                    onChange={handleSliderChange}
                  />
                  <span className="ml-2">{props.sliderValue.toFixed(2)}</span>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-5">
                  <label
                    className="form-label noselect"
                    htmlFor="consistency-switch"
                  >
                    Voice Consistency
                  </label>
                </div>
                <div className="col-7 settings-group">
                  <input
                    className="settings settings-light"
                    id="consistency-switch"
                    type="checkbox"
                    checked={props.voiceConsistency}
                    onChange={handleConsistencyToggle}
                  />
                  <label
                    className="settings-btn"
                    htmlFor="consistency-switch"
                  ></label>
                </div>
              </div>
            </div>
          )}
          <div className="row mb-2">
            <div className="col-5">
              <label className="form-label noselect" htmlFor="midi-switch">
                Enable MIDI
              </label>
            </div>
            <div className="col-6 settings-group">
              <input
                className="settings settings-light"
                id="midi-switch"
                type="checkbox"
                checked={props.enableMidiFlag}
                onChange={handleEnableMidi}
              />
              <label className="settings-btn" htmlFor="midi-switch"></label>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-5">
              <label className="form-label noselect" htmlFor="mic-wrong-input">
                Out-of-Scale Alert (MIC)
              </label>
            </div>
            <div className="col-6 settings-group">
              <input
                className="settings settings-light"
                id="mic-wrong-input"
                type="checkbox"
                checked={props.showWrongMicInput}
                onChange={() =>
                  props.setWrongMicInput(!props.showWrongMicInput)
                }
              />
              <label className="settings-btn" htmlFor="mic-wrong-input"></label>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-5">
              <label className="form-label noselect" htmlFor="wrong-midi-input">
                Out-of-Scale Alert (MIDI)
              </label>
            </div>
            <div className="col-6 settings-group">
              <input
                className="settings settings-light"
                id="wrong-midi-input"
                type="checkbox"
                checked={props.showWrongMidiInput}
                onChange={() =>
                  props.setWrongMidiInput(!props.showWrongMidiInput)
                }
              />
              <label
                className="settings-btn"
                htmlFor="wrong-midi-input"
              ></label>
            </div>
          </div>
          {props.enableMidi && (
            <div className="row mb-2">
              <div className="col-5">
                <label className="form-label noselect" htmlFor="midi-switch">
                  MIDI Volume
                </label>
              </div>
              <div className="col-6 settings-group">
                <input
                  type="range"
                  min="0"
                  max="10"
                  value={props.midiVolume}
                  className="slider"
                  id="myRange"
                  //   onChange={(event) => {
                  //     props.setMidiVolume(event.target.value);
                  //   }}
                ></input>
              </div>
            </div>
          )}
          <div className="row mb-2">
            <div className="col-5">
              <label className="form-label noselect" htmlFor="sustain-pedal-type">
                Non-Traditional Sustain Pedal
              </label>
            </div>
            <div className="col-6 settings-group">
              <input
                className="settings settings-light"
                id="sustain-pedal-type"
                type="checkbox"
                checked={props.sustainPedalNTToggle}
                onChange={() =>
                  props.setSustainPedalNTToggle(!props.sustainPedalNTToggle)
                }
              />
              <label
                className="settings-btn"
                htmlFor="sustain-pedal-type"
              ></label>
            </div>
          </div>
          <div className="row  mb-2">
            <div className="col-5">
              <label className="form-label noselect">Piano Lables</label>
            </div>
            <div className="col-7 text-left">
              <button
                className="btn btn_primary mr-2"
                onClick={props.toggleLabelsModalFunc}
              >
                Select Lables
              </button>
            </div>
          </div>
          <div className="row  mb-2">
            <div className="col-5">
              <label className="form-label noselect">Vocal Range</label>
            </div>
            <div className="col-7 text-left">
              <button
                className="btn btn_primary mr-2"
                onClick={props.toggleVocalModalFunc}
              >
                Set Vocal Range
              </button>
            </div>
          </div>

          <div className="row  mb-2">
            <div className="col-5">
              <label className="form-label noselect">Music Theory</label>
            </div>
            <div className="col-7 text-left">
              <button
                className="btn btn_primary mr-2"
                onClick={props.toggleMusicTheoryModalFunc}
              >
                Set Music Theory
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    voiceDetect: state.voiceDetect,
    sliderValue: state.sliderValue,
    voiceConsistency: state.voiceConsistency,
    enableMidiFlag: state.enableMidiFlag,
    widgetStarted: state.widgetStarted,
    showGhost: state.showGhost,
    autoLabel: state.autoLabel,
    applyGhost: state.applyGhost,
    showWrongMicInput: state.showWrongMicInput,
    showWrongMidiInput: state.showWrongMidiInput,
    sustainPedalNTToggle: state.sustainPedalNTToggle,
  };
};

const mapDispatchToProps = {
  setVoice,
  setMicValue,
  setConsistency,
  setEnableMidiFlag,
  setWidgetStarted,
  setShowGhost,
  setAutoLabel,
  setApplyGhost,
  setWrongMicInput,
  setWrongMidiInput,
  setSustainPedalNTToggle,
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPopup);
